import { render, staticRenderFns } from "./MailingsStatementsBatch.vue?vue&type=template&id=d082cdc2&scoped=true&"
import script from "./MailingsStatementsBatch.vue?vue&type=script&lang=ts&"
export * from "./MailingsStatementsBatch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d082cdc2",
  null
  
)

export default component.exports